import { createSelector } from '@reduxjs/toolkit';

import { Station } from '@paragon/contract-library';

import { RootState } from '../index';

export const getActiveStation = createSelector(
  (state: RootState) => state.application.openContext,
  (state: RootState) => state.stations,
  (openContext, stations): Station | null =>
    openContext?.type === 'station' || openContext?.type === 'schedule-station'
      ? (stations[openContext.stationGuid] ?? null)
      : null,
);
